import path from 'ramda/src/path'
import pathOr from 'ramda/src/pathOr'
import head from 'ramda/src/head'
import equals from 'ramda/src/equals'
import { ternary } from 'root/src/shared/util/ramdaPlus'
import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { pathOrFormInputs } = formStoreLenses

export default (state, { moduleKey, fieldPath, fieldStorePath, fieldDefault }) => {
	const storeValue = typeof fieldStorePath !== 'undefined'
		? path(fieldStorePath, state)
		: fieldDefault

	const pathValue = pathOrFormInputs(moduleKey, {}, state)
	const value = ternary(
		equals(head(fieldPath), 'pledgeAmount'),
		ternary(
			path(fieldPath, pathValue) === undefined,
			pathOr(5, fieldPath, pathValue),
			pathOr(null, fieldPath, pathValue),
		),
		path(fieldPath, pathValue),
	)

	if (typeof value === 'undefined') {
		return storeValue || fieldDefault || ''
	}

	return value
}
